module.exports = __webpack_public_path__ + "static/contact_img-a7656332099108b9e98e7ecae5aa9d2c.jpg";